import { render, staticRenderFns } from "./CompanyTaxInfo.vue?vue&type=template&id=56a02797"
import script from "./CompanyTaxInfo.vue?vue&type=script&lang=js"
export * from "./CompanyTaxInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports